import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core'; // <-- FIXED IMPORT
import { firstValueFrom } from 'rxjs';
import { ViewIdCardService } from './view-id-card.service';
import { CommonModule } from '@angular/common';
import * as idCardString from "../stringFiles/idCard.json";
import { FormsModule } from '@angular/forms';
import { ButtonLoaderComponent } from "../button-loader/button-loader.component";
import { NewLoaderComponent } from '../new-loader/new-loader.component';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;
declare var customToastr: any;

@Component({
  selector: 'app-view-id-card',
  // standalone: true,
  // imports: [CommonModule, FormsModule, ButtonLoaderComponent],
  templateUrl: './view-id-card.component.html',
  styleUrls: ['./view-id-card.component.css', '../transfer-certificate-preview/transfer-certificate-preview.component.css']
})
export class ViewIdCardComponent implements OnChanges {
  @Input() jobId!: string;
  @Input() serviceId!: string;
  @Output() backArrowClicked = new EventEmitter<void>();
  @Input() activeTab: string;
  zipFileUrl : any;
  isFetchingIds : any = true;
  isFetchingStaffIds: any = true;
  string : any;
  openIdPreview
  searchData: string = '';
  searchStaffData: string = '';
  emailIdData : string = "";
  sendingMail :  any = false;
    idCardInfo: any[] = [];
      currentIndex : any = 0;
  selectedIdCard : any;

  // function to change the value in parent
  onBackArrowClick() { 
    this.backArrowClicked.emit();
  }
  
  

  constructor(private viewIdService: ViewIdCardService, private translate: TranslateService) {
    this.string = idCardString;
  }

  // function to call api after recieving job id 

ngOnChanges() {
    if (this.jobId && this.activeTab) {
      if (this.activeTab === 'student') {
        this.getDataFromJobId(this.jobId);
      } else if (this.activeTab === 'staff') {
        this.getStaffDataFromJobId(this.jobId);
      }
    }
  }

  // function to get job data
  async getDataFromJobId(jobId: string) {
    try {
      
      const response: any = await firstValueFrom(this.viewIdService.getDataFromJobId(jobId));
      if (response.status) {
        this.idCardInfo = response.body.idCardPreviewDetails.studentsIdCardData;
        this.zipFileUrl = response.body.idCardPreviewDetails.zipFileUrl;
        this.isFetchingIds = false;
      }
    } catch (error) {
             this.isFetchingIds = false;
      const somethingWentWrongMessageTranslation = await firstValueFrom(this.translate.get('somethingWentWrongMessage'))
      customToastr(error.error.message || somethingWentWrongMessageTranslation,"error")
    }
  }

  async getStaffDataFromJobId(jobId: string) {
    try{
    const response: any = await firstValueFrom(this.viewIdService.getStaffDataFromJobId(jobId));
      if (response.status) {
        this.idCardInfo = response.body.idCardPreviewDetails.staffIdCardData;
        this.zipFileUrl = response.body.idCardPreviewDetails.zipFileUrl;
        this.isFetchingStaffIds = false;
      }
    } catch (error) {
             this.isFetchingStaffIds = false;
      const somethingWentWrongMessageTranslation = await firstValueFrom(this.translate.get('somethingWentWrongMessage'))
      customToastr(error.error.message || somethingWentWrongMessageTranslation,"error")
    }
  }



  // function for download whole zip file
  async downloadTemplateForEdit() {
   try{
     const link = document.createElement("a");
    link.href = this.zipFileUrl;
    link.download = "template.xls";
    link.click();
    const fileDownloadMessageTranslation = await firstValueFrom(this.translate.get('fileDownloadMessage'))
    customToastr(fileDownloadMessageTranslation, this.string.success);
   }
   catch(error){
    const somethingWentWrongMessageTranslation = await firstValueFrom(this.translate.get('somethingWentWrongMessage'))
      customToastr(error.message || somethingWentWrongMessageTranslation, this.string.error);
   }
  }



  // function for open preview
  openPreview(key,index){
      this.currentIndex = index;
      this.openIdPreview = true;
      this.getSelectedIdCard()
  }

  // function to close preview
   closeParticularTcPreviewPopup(event: MouseEvent): void {
    this.openIdPreview = false;
  }

  // function to get selected id
  getSelectedIdCard(){
    this.selectedIdCard = this.idCardInfo[this.currentIndex];
  }

  // function to download pdf card
  async downloadPDFIdCard() {
   try{
       const response = await fetch(this.selectedIdCard.documentUrl, { credentials: 'include' });
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = this.selectedIdCard.studentName + ".pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    const fileDownloadMessageTranslation = await firstValueFrom(this.translate.get('fileDownloadMessage'))
    customToastr(fileDownloadMessageTranslation, this.string.success);
   }
   catch(error){
     const somethingWentWrongMessageTranslation = await firstValueFrom(this.translate.get('somethingWentWrongMessage'))
      customToastr(error.message ||  somethingWentWrongMessageTranslation, this.string.error);
   }
  }

  async downloadStaffPDFIdCard() {
   try{
       const response = await fetch(this.selectedIdCard.documentUrl, { credentials: 'include' });
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = this.selectedIdCard.staffName + ".pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    const fileDownloadMessageTranslation = await firstValueFrom(this.translate.get('fileDownloadMessage'))
    customToastr(fileDownloadMessageTranslation, this.string.success);
   }
   catch(error){
     const somethingWentWrongMessageTranslation = await firstValueFrom(this.translate.get('somethingWentWrongMessage'))
      customToastr(error.message ||  somethingWentWrongMessageTranslation, this.string.error);
   }
  }

  // function to print id card
async printIdCard() {
  try {
    const response = await fetch(this.selectedIdCard.documentUrl, { credentials: 'include' });
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    iframe.src = blobUrl;
    document.body.appendChild(iframe);
    iframe.onload = () => {
      iframe.contentWindow?.print();
    }
  } catch (error) {
    const somethingWentWrongMessageTranslation = await firstValueFrom(this.translate.get('somethingWentWrongMessage'))
    customToastr(error.message || somethingWentWrongMessageTranslation, this.string.error);
  }
}
  
  
// function to change id card
  navigateTc(data){
    this.currentIndex = this.currentIndex + (data);
     this.getSelectedIdCard();
  }

  // function for search
  get filteredIdCardInfo() {
  if (!this.searchData) return this.idCardInfo;
  const term = this.searchData.toLowerCase();
  return this.idCardInfo.filter(item =>
    (item.studentName && item.studentName.toLowerCase().includes(term)) ||
    (item.className && item.className.toLowerCase().includes(term)) ||
    (item.classNumber && item.classNumber.toString().toLowerCase().includes(term))
  );
}

get filteredStaffIdCardInfo() {
   if (!this.searchStaffData) return this.idCardInfo;
  const term = this.searchStaffData.toLowerCase();
  return this.idCardInfo.filter(item =>
    (item.staffName && item.staffName.toLowerCase().includes(term))
  );
}

  // function for open pop up for email send
    openPopUpForEmailSend() {
    $("#emailIdDataSent").modal("show");
  }

// function for close pop up for email send
   closePopUpForEmailSend() {
    $("#emailIdDataSent").modal("hide");
  }

  // function for send email 
  async sendIdOnEmailId(){
    try{
      const inputEmail = this.emailIdData.trim();
      const emailId = inputEmail.split(',');
      if(emailId.length===0 || inputEmail==""){
        const pleaseEnterMailIdTranslation = await firstValueFrom(this.translate.get('pleaseEnterMailId'))
          customToastr(pleaseEnterMailIdTranslation, this.string.error);
          return ;
      }
      this.sendingMail = true;
      const body= {
        emailIdList : emailId,
        lang : "en",
        jobDetailId : this.jobId
      }
      const response :any = await firstValueFrom(this.viewIdService.sendIdOnEmail(body))
      if(response.status){
        customToastr(response.body.message, this.string.success);
        this.emailIdData = '';
        this.closePopUpForEmailSend()
      }
      this.sendingMail = false;
    }
    catch(error){
      const somethingWentWrongMessageTranslation = await firstValueFrom(this.translate.get('somethingWentWrongMessage'))
      customToastr(error.error.message || somethingWentWrongMessageTranslation, this.string.error);
            this.sendingMail = false;
    }
  }

  async sendStaffIdOnEmail() {
    try {
    const inputEmail = this.emailIdData.trim();
      const emailId = inputEmail.split(',');
      if(emailId.length===0 || inputEmail==""){
        const pleaseEnterMailIdTranslation = await firstValueFrom(this.translate.get('pleaseEnterMailId'))
          customToastr(pleaseEnterMailIdTranslation, this.string.error);
          return ;
      }
      this.sendingMail = true;
      const body= {
        emailIdList : emailId,
        lang : "en",
        jobDetailId : this.jobId
      }
      const response :any = await firstValueFrom(this.viewIdService.sendStaffIdOnEmail(body))
      if(response.status){
        customToastr(response.body.message, this.string.success);
        this.emailIdData = '';
        this.closePopUpForEmailSend()
      }
      this.sendingMail = false;
    }
    catch(error){
      const somethingWentWrongMessageTranslation = await firstValueFrom(this.translate.get('somethingWentWrongMessage'))
      customToastr(error.error.message || somethingWentWrongMessageTranslation, this.string.error);
            this.sendingMail = false;
    
  }
}
  

}